import { useState, useEffect } from 'react';
import axios from 'axios';

const getRepoLanguages = (url) =>
  axios.get(url).then((res) => res.data).catch(() => ({}));

export const useGitHubStats = (username) => {
  const [languages, setLanguages] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const { data: repos } = await axios.get(
          `https://api.github.com/users/${username}/repos?per_page=100`
        );
        const langResults = await Promise.all(
          repos.map((repo) => getRepoLanguages(repo.languages_url))
        );
        const totals = {};
        langResults.forEach((langMap) => {
          Object.entries(langMap).forEach(([lang, bytes]) => {
            totals[lang] = (totals[lang] || 0) + bytes;
          });
        });
        setLanguages(totals);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, [username]);

  return { languages, loading, error };
};
